import { render, staticRenderFns } from "./additional-bags-table.vue?vue&type=template&id=928a9a04&scoped=true"
import script from "./additional-bags-table.vue?vue&type=script&lang=js"
export * from "./additional-bags-table.vue?vue&type=script&lang=js"
import style0 from "./additional-bags-table.vue?vue&type=style&index=0&id=928a9a04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928a9a04",
  null
  
)

export default component.exports